/* eslint-disable @typescript-eslint/ban-types */ import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _type_of } from "@swc/helpers/_/_type_of";
import qs from "query-string";
export var QueryParamsProxyHandler = /*#__PURE__*/ function() {
    "use strict";
    function QueryParamsProxyHandler(parsed) {
        var _this = this;
        _class_call_check(this, QueryParamsProxyHandler);
        this.parsed = parsed;
        this.getSingle = function(param) {
            if (!(param in _this.parsed)) {
                return undefined;
            }
            var _this_parsed_param;
            // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
            var value = (_this_parsed_param = _this.parsed[param]) !== null && _this_parsed_param !== void 0 ? _this_parsed_param : null;
            if (typeof value === "string") {
                return value;
            } else if (Array.isArray(value)) {
                var _value_;
                return (_value_ = value === null || value === void 0 ? void 0 : value[0]) !== null && _value_ !== void 0 ? _value_ : null;
            }
            return value;
        };
        this.getAll = function(param) {
            if (!(param in _this.parsed)) {
                return undefined;
            }
            var _this_parsed_param;
            // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
            var value = (_this_parsed_param = _this.parsed[param]) !== null && _this_parsed_param !== void 0 ? _this_parsed_param : null;
            if (typeof value === "string") {
                return [
                    value
                ];
            } else if ((typeof value === "undefined" ? "undefined" : _type_of(value)) === "object") {
                return value;
            }
            return null;
        };
        this.getOrDefault = function(param, defaultValue) {
            var _this_getSingle;
            return (_this_getSingle = _this.getSingle(param)) !== null && _this_getSingle !== void 0 ? _this_getSingle : defaultValue;
        };
        this.get = function(target, prop, receiver) {
            if (prop === "get") {
                return _this.getSingle;
            } else if (prop === "getAll") {
                return _this.getAll;
            } else if (prop === "getOrDefault") {
                return _this.getOrDefault;
            } else if (prop === "values") {
                return _this.values;
            } else if (prop === "toString") {
                return _this.toString.bind(_this);
            }
            return Reflect.get(target.values, prop, receiver);
        };
        this.ownKeys = function(target) {
            return Reflect.ownKeys(target.values);
        };
        this.getOwnPropertyDescriptor = function(target, prop) {
            return Reflect.getOwnPropertyDescriptor(target.values, prop);
        };
        this.toString = function() {
            return qs.stringify(_this.values);
        };
    }
    _create_class(QueryParamsProxyHandler, [
        {
            key: "values",
            get: function get() {
                return this.parsed;
            }
        }
    ]);
    return QueryParamsProxyHandler;
}();
export var proxyQueryParams = function(parsed) {
    var proxy = new QueryParamsProxyHandler(parsed);
    // Casts are needed because we're expanding Q to QueryParams<Q>, done using the proxy.
    return new Proxy(proxy, proxy);
};
